/** Contentful `product` content type fields. */
export interface ProductFields {
  uuid?: string;
  name: string;
  sku?: string;
  description?: unknown;
  characteristics?: unknown;
  images?: Array<{ sys: { id: string } }>;
  category?: { sys: { id: string } };
  /** Retail price (грн) */
  price?: number;
  /** Wholesale price (грн) */
  wholesalePrice?: number;
  /** Package size, e.g. "3шт" */
  package?: string;
  /**
   * Weight options. A plain value ("5") plus `units`, or Contentful entries
   * encoded as "amount:unit:price" (for example "1:кг:100").
   */
  weight?: string | number | string[];
  /** Unit for weight, e.g. "кг" */
  units?: string | number;
}

/** Build a display label from Contentful `weight` + `units`, e.g. "5 кг" or "1 кг, 2 кг". */
export function formatWeightLabel(
  weight: string | number | Array<string | number> | null | undefined,
  units: string | number | null | undefined,
): string | null {
  const entries = Array.isArray(weight) ? weight : [weight];
  const labels = entries
    .map((entry) => formatWeightEntry(entry, units))
    .filter((label): label is string => !!label);
  return labels.length ? labels.join(', ') : null;
}

function formatWeightEntry(
  weight: string | number | null | undefined,
  units: string | number | null | undefined,
): string | null {
  const value = textOf(weight);
  if (!value) return null;

  const [amount, unit] = value.split(':');
  if (unit != null && amount.trim() && unit.trim() && !unit.includes(' ')) {
    return `${amount.trim()} ${unit.trim()}`;
  }

  const fallbackUnit = textOf(units);
  return fallbackUnit ? `${value} ${fallbackUnit}` : value;
}

function textOf(value: string | number | null | undefined): string {
  if (value == null) return '';
  return String(value).trim();
}
